import React from "react";
import { Container, Row, Col } from "reactstrap";
import appConfig from "../data/appConfig";

const validateEmail = (email) => {
  // will return true or false
  var re = /\S+@\S+\.\S+/;
  return re.test(email);
};

const getCheckedRadioValue = (input_name) => {
  var ele = document.getElementsByName(input_name);
  for (i = 0; i < ele.length; i++) {
    if (ele[i].checked) return ele[i].value;
  }
};

const jsXOR = (a, b) => {
  // JavaScript XOR
  return (a || b) && !(a && b);
};

class InputForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = { value: "0" };
    this.state = { dispContact: true };
    this.state = { showSummary: false, inputSummary: "" };

    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    // to prevent contact being hidden after first load
    this.setState({ value: "0" });
    this.setState({ dispContact: true });
  }

  handleClick(event) {
    if (event.target.value === "1") {
      this.setState({ value: 0 });
      this.setState({ dispContact: true });
    } else {
      this.setState({ value: 1 });
      this.setState({ dispContact: false });
    }
  }

  handleModify = () => {
    this.setState({ showSummary: false });
  };

  handleSubmit = () => {
    // submit the form
    document.getElementById("app_form").submit();
  };

  render() {
    //const destURL = "http://localhost/baus/tablets/tablets-form2.php"; // local
    const destURL = appConfig["appSet"]["link"] + "/tablets-form2.php";

    const ValidateForm = (event) => {
      // initialize the variables
      const arrContact = [
        "捐款者姓名 Donor Name",
        "捐款者電郵 Donor Email",
        "捐款者電話 Donor Phone",
        "連絡者同捐款者 Contact info same as Donor",
        "連絡者姓名 Contact Name",
        "連絡者電郵 Contact Email",
        "連絡者電話 Contact Phone",
      ];
      const arrMisc = [
        "供僧 For Sangha",
        "法會捐款 For Ceremony",
        "供花果 For Flower/Fruit",
        "備註 Remarks",
      ];

      const xiaozaiTblt = ["消災牌位", "Tablets for blessing"];
      const wangshengTblt = ["超薦牌位", "Tablets for delivering the deceased"];
      const ancestor = "氏歷代祖先";
      const respectAndRepent = "個人歷劫父母師長暨寃親債主";
      const babySpirit = "嬰靈";
      const firstColumnWarning = "請先填第一欄 (column)";
      const firstRowWarning = "請先填第一行 (row)";
      const bothNamesRequired = "兩個名字都是必填欄 (Both names are required)";
      const donorIsContact = "連絡者同捐款者 Contact info same as Donor";
      const nonTbltDonation = "非牌位捐款 Non-tablet Donation";
      const totalToPay = "待付總金額 Total Amount to be paid at Paypal";
      const livingName = " 陽上 (Living) : ";

      const tbltPrice = 20; // tablet price
      const tblt2Price = tbltPrice; // same for both xiaozai and wangsheng
      const maxXiaozaiNum = 3; // total xiaozai tablets
      const maxNameNum = 2; // max number of names on a tablet
      const maxWangshengNum = 8; // total wangsheng tablets
      const maxComments = 250; // total comments length acceptable

      event.preventDefault();
      const tempForm = new FormData(event.target);
      //console.log(tempForm); // this one give you the whole Form object
      const frmElements = []; // initialize the array to hold all Form inputs
      for (let [key, value] of tempForm.entries()) {
        frmElements[key] = value;
      }

      // if the donor is not the contact, make sure contact info is filled
      if (!tempForm.get("donor_contact")) {
        if (
          !tempForm.get("contact[1][0]") ||
          !tempForm.get("contact[1][1]") ||
          !tempForm.get("contact[1][2]")
        ) {
          alert(
            "若連絡者與捐款者非同一人, 連絡者姓名, 電郵, 電話 為必填欄 Contact Name, Email, and Phone are required.",
          );
          return;
        }
      }

      // ask user to fill in 1st column, first row first
      if (!tempForm.get("xiaozai[0][0]") && tempForm.get("xiaozai[0][1]")) {
        alert(xiaozaiTblt[0] + " 1: " + firstColumnWarning);
        return;
      }
      if (!tempForm.get("xiaozai[1][0]") && tempForm.get("xiaozai[1][1]")) {
        alert(xiaozaiTblt[0] + " 2: " + firstColumnWarning);
        return;
      }
      if (!tempForm.get("xiaozai[2][0]") && tempForm.get("xiaozai[2][1]")) {
        alert(xiaozaiTblt[0] + " 3: " + firstColumnWarning);
        return;
      }
      if (!tempForm.get("xiaozai[0][0]") && tempForm.get("xiaozai[1][0]")) {
        alert(xiaozaiTblt[0] + " 2: " + firstRowWarning);
        return;
      }
      if (!tempForm.get("xiaozai[1][0]") && tempForm.get("xiaozai[2][0]")) {
        alert(xiaozaiTblt[0] + " 3: " + firstRowWarning);
        return;
      }

      if (!tempForm.get("wangsheng[0][0]") && tempForm.get("wangsheng[1][0]")) {
        alert(wangshengTblt[0] + " 2: " + firstRowWarning);
        return;
      }

      // make sure if anything entered in wangsheng 1-5, 7-8, both names are required
      if (
        jsXOR(tempForm.get("wangsheng[0][0]"), tempForm.get("wangsheng[0][1]"))
      ) {
        alert(wangshengTblt[0] + " 1: " + bothNamesRequired);
        return;
      }
      if (
        jsXOR(tempForm.get("wangsheng[1][0]"), tempForm.get("wangsheng[1][1]"))
      ) {
        alert(wangshengTblt[0] + " 2: " + bothNamesRequired);
        return;
      }
      if (
        jsXOR(tempForm.get("wangsheng[2][0]"), tempForm.get("wangsheng[2][1]"))
      ) {
        alert(wangshengTblt[0] + " 3: " + bothNamesRequired);
        return;
      }
      if (
        jsXOR(tempForm.get("wangsheng[3][0]"), tempForm.get("wangsheng[3][1]"))
      ) {
        alert(wangshengTblt[0] + " 4: " + bothNamesRequired);
        return;
      }
      if (
        jsXOR(tempForm.get("wangsheng[6][0]"), tempForm.get("wangsheng[6][1]"))
      ) {
        alert(wangshengTblt[0] + " 7: " + bothNamesRequired);
        return;
      }
      if (
        jsXOR(tempForm.get("wangsheng[7][0]"), tempForm.get("wangsheng[7][1]"))
      ) {
        alert(wangshengTblt[0] + " 8: " + bothNamesRequired);
        return;
      }

      // check if there is anything filled in wangsheng section
      // if any tablet is fill, its living name has to be field
      let wangshengFilled = false;
      for (let i = 0; i < 8; i++) {
        let elementKey = "wangsheng[" + i + "][1]";
        if (tempForm.get(elementKey)) {
          wangshengFilled = true;
          break;
        }
      }

      // check the total of misc donation
      let miscSubtotal = 0;
      if (tempForm.get("misc[sangha]")) {
        miscSubtotal += parseFloat(tempForm.get("misc[sangha]"));
      }
      if (tempForm.get("misc[ceremony]")) {
        miscSubtotal += parseFloat(tempForm.get("misc[ceremony]"));
      }
      if (tempForm.get("misc[flowerfruit]")) {
        miscSubtotal += parseFloat(tempForm.get("misc[flowerfruit]"));
      }

      // make sure at least one section is filled
      if (
        !tempForm.get("xiaozai[0][0]") &&
        !wangshengFilled &&
        miscSubtotal === 0
      ) {
        alert(
          "牌位或捐款不能同時空白 Tablet or donations cannot be all blank. Please try again.",
        );
        return;
      }

      // check comments length
      if (tempForm.get("comments").length > maxComments) {
        alert(
          "備註欄請勿超過 " +
            maxComments +
            " 字. Please limit your Remarks to less than " +
            maxComments +
            " characters",
        );
        return;
      }

      // start to build summary
      let totalSummary =
        '<p style="padding-top: 15px">查看總數 View Summary</p>';

      // build contact section summary
      let contactSectSummary = "";
      contactSectSummary +=
        arrContact[0] + ": " + tempForm.get("contact[0][0]") + "<br />";
      contactSectSummary +=
        arrContact[1] + ": " + tempForm.get("contact[0][1]") + "<br />";
      contactSectSummary +=
        arrContact[2] + ": " + tempForm.get("contact[0][2]") + "<br />";
      if (!tempForm.get("donor_contact")) {
        contactSectSummary +=
          arrContact[4] + ": " + tempForm.get("contact[1][0]") + "<br />";
        contactSectSummary +=
          arrContact[5] + ": " + tempForm.get("contact[1][1]") + "<br />";
        contactSectSummary +=
          arrContact[6] + ": " + tempForm.get("contact[1][2]") + "<br />";
      } else {
        contactSectSummary += donorIsContact + "<br />";
      }
      totalSummary += contactSectSummary + "<hr />";

      // build xiaozai section summary
      let xiaozaiSectSummary = "";
      let xiaozaiTbltNum = 0;
      for (let i = 0; i < maxXiaozaiNum; i++) {
        for (let j = 0; j < maxNameNum; j++) {
          let tempKey = "xiaozai[" + i + "][" + j + "]";
          if (!tempForm.get(tempKey)) {
            break;
          } else {
            if (j === 0) {
              if (xiaozaiSectSummary.length > 0) {
                // close previous tblt if it exists
                xiaozaiSectSummary += "<br />";
              }
              xiaozaiTbltNum++; // actual xiaozai tablet number requested
              xiaozaiSectSummary +=
                xiaozaiTblt[0] +
                " " +
                xiaozaiTblt[1] +
                " " +
                parseInt(i + 1) +
                ": " +
                tempForm.get(tempKey);
            } else {
              xiaozaiSectSummary += "; " + tempForm.get(tempKey);
            }
          }
        }
      }
      if (xiaozaiSectSummary.length > 0) {
        totalSummary += xiaozaiSectSummary + "<hr />";
      }

      // build wangsheng section summary
      let wangshengSectSummary = ""; // wangsheng section related string to be displayed
      let wangshengTbltNum = 0;
      let tempKey = "";
      let tempKey1 = "";
      for (let i = 0; i < maxWangshengNum; i++) {
        switch (i) {
          case 0:
          case 1:
            tempKey = "wangsheng[" + i + "][0]";
            if (!tempForm.get(tempKey)) {
              break;
            } else {
              let tempKey1 = "wangsheng[" + i + "][1]";
              if (wangshengSectSummary.length > 0) {
                // close previous tblt if it exists
                wangshengSectSummary += "<br />";
              }
              wangshengTbltNum++; // actual wangsheng tablet number requested
              wangshengSectSummary +=
                wangshengTblt[0] +
                " " +
                wangshengTblt[1] +
                " " +
                parseInt(i + 1) +
                ": " +
                tempForm.get(tempKey) +
                "; " +
                livingName +
                tempForm.get(tempKey1);
            }
            break;
          case 2:
          case 3:
            tempKey = "wangsheng[" + i + "][0]";
            if (!tempForm.get(tempKey)) {
              break;
            } else {
              let tempKey1 = "wangsheng[" + i + "][1]";
              if (wangshengSectSummary.length > 0) {
                // close previous tblt if it exists
                wangshengSectSummary += "<br />";
              }
              wangshengTbltNum++; // actual wangsheng tablet number requested
              wangshengSectSummary +=
                wangshengTblt[0] +
                " " +
                wangshengTblt[1] +
                " " +
                parseInt(i + 1) +
                ": " +
                tempForm.get(tempKey) +
                ancestor +
                "; " +
                livingName +
                tempForm.get(tempKey1);
            }
            break;
          case 4:
          case 5:
            tempKey1 = "wangsheng[" + i + "][1]";
            if (!tempForm.get(tempKey1)) {
              break;
            } else {
              if (wangshengSectSummary.length > 0) {
                // close previous tblt if it exists
                wangshengSectSummary += "<br />";
              }
              wangshengTbltNum++;
              wangshengSectSummary +=
                wangshengTblt[0] +
                " " +
                wangshengTblt[1] +
                " " +
                parseInt(i + 1) +
                ": " +
                respectAndRepent +
                "; " +
                livingName +
                tempForm.get(tempKey1);
            }
            break;
          case 6:
            tempKey = "wangsheng[" + i + "][0]";
            if (!tempForm.get(tempKey)) {
              break;
            } else {
              let tempKey1 = "wangsheng[" + i + "][1]";
              if (wangshengSectSummary.length > 0) {
                // close previous tblt if it exists
                wangshengSectSummary += "<br />";
              }
              wangshengTbltNum++; // actual xiaozai tablet number requested
              wangshengSectSummary +=
                wangshengTblt[0] +
                " " +
                wangshengTblt[1] +
                " " +
                parseInt(i + 1) +
                ": " +
                babySpirit +
                " " +
                tempForm.get(tempKey) +
                "; " +
                livingName +
                tempForm.get(tempKey1);
            }
            break;
          case 7:
            tempKey = "wangsheng[" + i + "][0]";
            if (!tempForm.get(tempKey)) {
              break;
            } else {
              let tempKey1 = "wangsheng[" + i + "][1]";
              if (wangshengSectSummary.length > 0) {
                // close previous tblt if it exists
                wangshengSectSummary += "<br />";
              }
              wangshengTbltNum++; // actual wangsheng tablet number requested
              wangshengSectSummary +=
                wangshengTblt[0] +
                " " +
                wangshengTblt[1] +
                " " +
                parseInt(i + 1) +
                ": " +
                tempForm.get(tempKey) +
                "; " +
                livingName +
                tempForm.get(tempKey1);
            }
            break;
        }
      }

      if (wangshengSectSummary.length > 0) {
        totalSummary += wangshengSectSummary + "<hr />";
      }

      // build misc section summary
      let miscSectSummary = "";
      let miscSectTotal = 0;
      if (tempForm.get("misc[sangha]")) {
        miscSectTotal += parseFloat(tempForm.get("misc[sangha]"));
        miscSectSummary +=
          arrMisc[0] + ": $" + tempForm.get("misc[sangha]") + "<br />";
      }
      if (tempForm.get("misc[ceremony]")) {
        miscSectTotal += parseFloat(tempForm.get("misc[ceremony]"));
        miscSectSummary +=
          arrMisc[1] + ": $" + tempForm.get("misc[ceremony]") + "<br />";
      }
      if (tempForm.get("misc[flowerfruit]")) {
        miscSectTotal += parseFloat(tempForm.get("misc[flowerfruit]"));
        miscSectSummary +=
          arrMisc[2] + ": $" + tempForm.get("misc[flowerfruit]") + "<br />";
      }

      if (miscSectSummary.length > 0) {
        totalSummary += miscSectSummary + "<hr />";
      }

      // build comments
      if (tempForm.get("comments") && tempForm.get("comments").length > 0) {
        totalSummary += "Remarks:<br />" + tempForm.get("comments") + "<hr />";
      }

      // build sub-total
      let subtotalSummary = "分類小計 Section Sub-total: <br />";
      let subtotalXiaozai = 0;
      let subtotalWangsheng = 0;

      if (xiaozaiTbltNum > 0) {
        subtotalXiaozai = xiaozaiTbltNum * tbltPrice;
        subtotalSummary +=
          xiaozaiTblt[0] +
          " " +
          xiaozaiTblt[1] +
          ": $" +
          subtotalXiaozai +
          "<br />";
      }

      if (wangshengTbltNum > 0) {
        subtotalWangsheng = wangshengTbltNum * tblt2Price;
        subtotalSummary +=
          wangshengTblt[0] +
          " " +
          wangshengTblt[1] +
          ": $" +
          subtotalWangsheng +
          "<br />";
      }

      if (miscSectTotal > 0) {
        subtotalSummary += nonTbltDonation + ": $" + miscSectTotal + "<br />";
      }
      totalSummary += subtotalSummary + "<hr />";

      // total to pay
      let total = subtotalXiaozai + subtotalWangsheng + miscSectTotal;
      totalSummary += totalToPay + ": $" + total;

      this.setState({ showSummary: true });
      this.setState({ inputSummary: totalSummary });
      return;
    };

    return (
      <Container fluid={false} className="input-form">
        <Row style={{ display: this.state.showSummary ? "block" : "none" }}>
          <Col>
            <div
              className="frm-summary"
              id="frm_summary"
              dangerouslySetInnerHTML={{ __html: this.state.inputSummary }}
            ></div>
            <div className="act-buttons">
              <button
                type="submit"
                name="btnSummary"
                style={{ width: "250px" }}
                id="formSubmit"
                onClick={this.handleSubmit}
              >
                SUBMIT AND GO TO PAYPAL
              </button>
              &nbsp;
              <button
                type="submit"
                name="btnSummary"
                style={{ width: "250px" }}
                id="formSubmit"
                onClick={this.handleModify}
              >
                MODIFY INPUTS
              </button>
            </div>
          </Col>
        </Row>
        <Row style={{ display: this.state.showSummary ? "none" : "block" }}>
          <Col>
            <p className="frm-notes highlight highlight-color">
              名字若太長，將全名寫在下面的備註欄。
              <br />
              If the name is too long, write the complete name in the bottom
              Remark box
            </p>
          </Col>
        </Row>
        <form
          id="app_form"
          method="post"
          action={destURL}
          onSubmit={ValidateForm}
          style={{ display: this.state.showSummary ? "none" : "block" }}
        >
          <Row>
            <Col className="contact-section">
              <h4>捐款者資訊 Donor Info</h4>
              <Row className="donor-wrapper">
                <Col xs="12" sm="4">
                  <label htmlFor="d_name">姓名&nbsp;</label>
                  <input
                    type="text"
                    name="contact[0][0]"
                    placeholder="Full Name"
                    maxLength="6"
                    id="d_name"
                    required
                  />
                </Col>
                <Col xs="12" sm="4">
                  <label htmlFor="d_email">電郵&nbsp;</label>
                  <input
                    type="email"
                    name="contact[0][1]"
                    placeholder="Email"
                    maxLength="40"
                    id="d_email"
                    required
                  />
                </Col>
                <Col xs="12" sm="4">
                  <label htmlFor="d_phone">電話&nbsp;</label>
                  <input
                    type="text"
                    name="contact[0][2]"
                    pattern="^[0-9()-1{e}1{x}1{t}]*$"
                    title="Must contain only numbers 0 - 9, (, ), -, e, x, and t"
                    placeholder="Phone"
                    maxLength="30"
                    id="d_phone"
                    required
                  />
                </Col>
              </Row>

              <Row>
                <Col xs="12" sm="6">
                  <h4 style={{ margin: "10px 0" }}>
                    連絡者資訊 Contact Info　
                  </h4>
                </Col>
                <Col xs="12" sm="6" className="same-as-donor highlight">
                  <input
                    type="checkbox"
                    name="donor_contact"
                    onClick={this.handleClick}
                    style={{ width: "20px" }}
                    value={this.state.value}
                    id="donor_contact"
                  />
                  <label htmlFor="donor_contact">
                    &nbsp;捐款者即連絡者 Donor is Contact
                  </label>
                </Col>
              </Row>
              {this.state.dispContact ? (
                <Row className="contact-wrapper">
                  <Col xs="12" sm="4">
                    <label htmlFor="c_name">姓名&nbsp;</label>
                    <input
                      type="text"
                      name="contact[1][0]"
                      placeholder="Full Name"
                      maxLength="6"
                      id="c_name"
                    />
                  </Col>
                  <Col xs="12" sm="4">
                    <label htmlFor="c_email">電郵&nbsp;</label>
                    <input
                      type="email"
                      name="contact[1][1]"
                      placeholder="Email"
                      maxLength="40"
                      id="c_email"
                    />
                  </Col>
                  <Col xs="12" sm="4">
                    <label htmlFor="c_phone">電話&nbsp;</label>
                    <input
                      type="text"
                      name="contact[1][2]"
                      pattern="^[0-9()-1{e}1{x}1{t}]*$"
                      title="Must contain only numbers 0 - 9, (, ), -, e, x, and t"
                      placeholder="Phone"
                      maxLength="30"
                      id="c_phone"
                    />
                  </Col>
                </Row>
              ) : (
                <div></div>
              )}
            </Col>
          </Row>

          <Row>
            <Col className="section-the-blessing">
              <div className="section-title highlight highlight-color">
                消災牌位 Tablets for blessing 每個牌位 (each) $20
              </div>
              <Row className="section-hero">
                <Col xs="12" style={{ textAlign: "center" }}>
                  <span className="highlight-color">
                    生者姓名 Name of Beneficiary
                    <br />
                    每個牌位最多可寫兩個姓名, up to 2 names per Tablet
                  </span>
                </Col>
              </Row>
              <Row>
                <Col xs="12" sm="4">
                  <span>牌位 1</span>
                </Col>
                <Col xs="12" sm="4">
                  <input
                    type="text"
                    name="xiaozai[0][0]"
                    maxLength="6"
                    placeholder="姓名 Full Name"
                    id="xiaozai_0_0"
                  />
                </Col>
                <Col xs="12" sm="4">
                  <input
                    type="text"
                    name="xiaozai[0][1]"
                    maxLength="6"
                    placeholder="姓名 Full Name"
                    id="xiaozai_0_1"
                  />
                </Col>
              </Row>
              <Row>
                <Col xs="12" sm="4">
                  <span>牌位 2</span>
                </Col>
                <Col xs="12" sm="4">
                  <input
                    type="text"
                    name="xiaozai[1][0]"
                    maxLength="6"
                    placeholder="姓名 Full Name"
                    id="xiaozai_1_0"
                  />
                </Col>
                <Col xs="12" sm="4">
                  <input
                    type="text"
                    name="xiaozai[1][1]"
                    maxLength="6"
                    placeholder="姓名 Full Name"
                    id="xiaozai_1_1"
                  />
                </Col>
              </Row>
              <Row>
                <Col xs="12" sm="4">
                  <span>牌位 3</span>
                </Col>
                <Col xs="12" sm="4">
                  <input
                    type="text"
                    name="xiaozai[2][0]"
                    maxLength="6"
                    placeholder="姓名 Full Name"
                    id="xiaozai_2_0"
                  />
                </Col>
                <Col xs="12" sm="4">
                  <input
                    type="text"
                    name="xiaozai[2][1]"
                    maxLength="6"
                    placeholder="姓名 Full Name"
                    id="xiaozai_2_1"
                  />
                </Col>
              </Row>
            </Col>
          </Row>

          <Row style={{ marginTop: "20px" }}>
            <Col className="section-the-deceased">
              <div className="section-title highlight highlight-color">
                超薦牌位 Tablets for delivering the deceased 每個牌位 (each) $20
              </div>
              <Row className="section-hero">
                <Col xs="12" style={{ textAlign: "center" }}>
                  <span className="highlight-color">
                    亡者 / 陽上姓名 Name of Deceased / Living
                  </span>
                </Col>
              </Row>
              <Row>
                <Col xs="12" sm="4">
                  <span>牌位 1: 亡者</span>
                </Col>
                <Col xs="12" sm="4">
                  <input
                    type="text"
                    name="wangsheng[0][0]"
                    maxLength="6"
                    placeholder="亡者 Deceased name"
                    id="wangsheng_0_0"
                  />
                </Col>
                <Col xs="12" sm="4">
                  <input
                    type="text"
                    name="wangsheng[0][1]"
                    maxLength="6"
                    placeholder="陽上 Living Name"
                    id="wangsheng_0_1"
                  />
                </Col>
              </Row>
              <Row>
                <Col xs="12" sm="4">
                  <span>牌位 2: 亡者</span>
                </Col>
                <Col xs="12" sm="4">
                  <input
                    type="text"
                    name="wangsheng[1][0]"
                    maxLength="6"
                    placeholder="亡者 Deceased name"
                    id="wangsheng_1_0"
                  />
                </Col>
                <Col xs="12" sm="4">
                  <input
                    type="text"
                    name="wangsheng[1][1]"
                    maxLength="6"
                    placeholder="陽上 Living Name"
                    id="wangsheng_1_1"
                  />
                </Col>
              </Row>
              <Row>
                <Col xs="12" sm="4">
                  <span>牌位 3: 歷代祖先</span>
                </Col>
                <Col xs="12" sm="4">
                  <input
                    type="text"
                    name="wangsheng[2][0]"
                    style={{ width: "50px" }}
                    maxLength={2}
                    placeholder="?"
                    id="wangsheng_2_0"
                  />{" "}
                  氏歷代祖先
                </Col>
                <Col xs="12" sm="4">
                  <input
                    type="text"
                    name="wangsheng[2][1]"
                    maxLength="6"
                    placeholder="陽上 Living Name"
                    id="wangsheng_2_1"
                  />
                </Col>
              </Row>
              <Row>
                <Col xs="12" sm="4">
                  <span>牌位 4: 歷代祖先</span>
                </Col>
                <Col xs="12" sm="4">
                  <input
                    type="text"
                    name="wangsheng[3][0]"
                    style={{ width: "50px" }}
                    maxLength={2}
                    placeholder="?"
                    id="wangsheng_3_0"
                  />{" "}
                  氏歷代祖先
                </Col>
                <Col xs="12" sm="4">
                  <input
                    type="text"
                    name="wangsheng[3][1]"
                    maxLength="6"
                    placeholder="陽上 Living Name"
                    id="wangsheng_3_1"
                  />
                </Col>
              </Row>
              <Row>
                <Col xs="12" sm="4">
                  <span>牌位 5:</span>
                </Col>
                <Col xs="12" sm="4">
                  <span>個人歷劫父母師長暨寃親債主</span>
                </Col>
                <Col xs="12" sm="4">
                  <input
                    type="text"
                    name="wangsheng[4][1]"
                    maxLength="6"
                    placeholder="陽上 Living Name"
                    id="wangsheng_4_1"
                  />
                </Col>
              </Row>
              <Row>
                <Col xs="12" sm="4">
                  <span>牌位 6:</span>
                </Col>
                <Col xs="12" sm="4">
                  <span>個人歷劫父母師長暨寃親債主</span>
                </Col>
                <Col xs="12" sm="4">
                  <input
                    type="text"
                    name="wangsheng[5][1]"
                    maxLength="6"
                    placeholder="陽上 Living Name"
                    id="wangsheng_5_1"
                  />
                </Col>
              </Row>
              <Row>
                <Col xs="12" sm="4">
                  <span>牌位 7: 嬰靈</span>
                </Col>
                <Col xs="12" sm="4">
                  <input
                    type="text"
                    name="wangsheng[6][0]"
                    maxLength="20"
                    placeholder="嬰靈 Full Name"
                    id="wangsheng_6_0"
                  />
                </Col>
                <Col xs="12" sm="4">
                  <input
                    type="text"
                    name="wangsheng[6][1]"
                    maxLength="6"
                    placeholder="陽上 Living Name"
                    id="wangsheng_6_1"
                  />
                </Col>
              </Row>
              <Row>
                <Col xs="12" sm="4">
                  <span>牌位 8: 其他</span>
                </Col>
                <Col xs="12" sm="4">
                  <input
                    type="text"
                    name="wangsheng[7][0]"
                    maxLength="20"
                    placeholder=""
                    id="wangsheng_7_0"
                  />
                </Col>
                <Col xs="12" sm="4">
                  <input
                    type="text"
                    name="wangsheng[7][1]"
                    maxLength="12"
                    placeholder="陽上 Living Name"
                    id="wangsheng_7_1"
                  />
                </Col>
              </Row>
            </Col>
          </Row>

          <Row>
            <Col className="misc-section">
              <Row>
                <Col xs="12" sm="4">
                  供僧: ${" "}
                  <input
                    type="text"
                    name="misc[sangha]"
                    placeholder="To the Sangha"
                    pattern="^[0-9.]*$"
                    title="Must contain only numbers 0 - 9 and ."
                    className="misc_fields"
                    maxLength="10"
                    id="misc_sangha"
                  />
                </Col>
                <Col xs="12" sm="4">
                  法會供養: ${" "}
                  <input
                    type="text"
                    name="misc[ceremony]"
                    placeholder="For the Ceremony"
                    pattern="^[0-9.]*$"
                    title="Must contain only numbers 0 - 9 and ."
                    className="misc_fields"
                    maxLength="10"
                    id="misc_ceremony"
                  />
                </Col>
                <Col xs="12" sm="4">
                  供花果: ${" "}
                  <input
                    type="text"
                    name="misc[flowerfruit]"
                    placeholder="For Flower / Fruit"
                    pattern="^[0-9.]*$"
                    title="Must contain numbers 0 - 9 and . only"
                    className="misc_fields"
                    maxLength="10"
                    id="misc_flowerfruit"
                  />
                </Col>
              </Row>
              <Row>
                <Col xs="12" sm="6">
                  <div className="form-remarks">
                    備註 Remarks
                    <br />
                    <textarea name="comments" id="comments" rows="2"></textarea>
                  </div>
                </Col>
                <Col xs="12" sm="6" className="btn-submit">
                  <button
                    type="submit"
                    name="btnSummary"
                    style={{ width: "250px" }}
                    id="formSubmit"
                  >
                    查看總數 View Summary
                  </button>
                </Col>
              </Row>
            </Col>
          </Row>
        </form>
      </Container>
    );
  }
}

export default InputForm;
